import type { FC } from 'react';
import React from 'react';
import classNames from 'classnames';

import { Bubble, HintButton } from '@lt/components';
import CurrencyFormat from '../../../../components/CurrencyFormat';

import styles from './priceDetailsItem.module.css';

interface PriceDetailsItemProps {
  className?: string;
  price?: number | string;
  label: string;
  isReduction?: boolean;
  tooltipText?: string;
  children?: React.ReactNode;
}

const PriceDetailsItem: FC<PriceDetailsItemProps> = ({
  className,
  price,
  children,
  label,
  isReduction,
  tooltipText,
}) => (
  <li className={classNames(className, styles.row)}>
    <div className={styles.label}>{label}</div>
    <div className={styles.price}>
      {children || (
        <CurrencyFormat value={price} prefix={isReduction ? '-' : '+'} />
      )}
      {tooltipText && (
        <Bubble text={tooltipText}>
          <HintButton />
        </Bubble>
      )}
    </div>
  </li>
);

export default PriceDetailsItem;
